import { Box } from '@mui/material';

export const PanelSectionContainer = ({ children }: { children: React.ReactNode }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '0.5rem', width: '100%' }}>{children}</Box>
);
